import React from 'react';
import '../template-file-css/document-file-template.css';


export const MC_ComprehensiveClinicalAssessment = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='MC_ComprehensiveClinicalAssessment' className='file-pdf-document'>
        <div className='file-template'>

        <p className='w-750'><center><b>PRESENTING PROBLEM - PRECIPITATING FACTORS - CURRENT SYMPTOMS</b></center></p>
                <p className='w-750'>This is a &nbsp;
                    <input type='text' id='txtThisIs' name='txtThisIs' className='add-only w-50 custom-add-only' /> year old &nbsp;
                    <input type='text' id='txtYearOld' name='txtYearOld' className='add-only w-200 custom-add-only' />  with a history of &nbsp;
                    <input type='text' id='txtWithHistoryOf' name='txtWithHistoryOf' className='add-only w-250 custom-add-only' />
                </p>

                <p className='w-750'><span className='eleHeader'>who presents with the following symptoms: </span>
                    <textarea id='txtFollowingSymptoms' name='txtFollowingSymptoms' className='add-only' ></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>Problems began with: </span>
                    <textarea id='txtProblemBeganWith' name='txtProblemBeganWith' className='add-only' ></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>Precipitating Event: </span>
                    <textarea id='txtPrecipitatingEvent' name='txtPrecipitatingEvent' className='add-only' ></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>Source of Distress: </span>
                    <textarea id='txtSourceDistress' name='txtSourceDistress' className='add-only' ></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>Stressors include: </span>
                    <textarea id='txtStressorsInclude' name='txtStressorsInclude' className='add-only' ></textarea>
                </p>

                <p className='w-750'><b>For Crisis Planning Purposes:</b></p>

                <p className='w-750'><span className='eleHeader'>Give an example of what helped you or didn&#39;t help you in a previous crisis </span>
                    <textarea id='txtExampleWhatHelpedPrevious' name='txtExampleWhatHelpedPrevious' className='add-only' ></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>How best to support me in a crisis situation? </span>
                    <textarea id='txtBestSupportCrisisSituation' name='txtBestSupportCrisisSituation' className='add-only' ></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>1. What people like and admire about me… </span>
                    <textarea id='txtPeopleLikeAndAdmire' name='txtPeopleLikeAndAdmire' className='add-only' ></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>2. What&#39;s important to me… </span>
                    <textarea id='txtWhatImportantToMe' name='txtWhatImportantToMe' className='add-only' ></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>3. What&#39;s working in my life… </span>
                    <textarea id='txtWorkingInLife' name='txtWorkingInLife' className='add-only' ></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>4. What not working… </span>
                    <textarea id='txtWhatNotWorking' name='txtWhatNotWorking' className='add-only' ></textarea>
                </p>

                <p className='w-750'><h3>Psychiatric History</h3></p>

                <p className='w-750'><span className='eleHeader'>Are you currently receiving services with any behavioral health provider?</span>
                    <input type='radio' id='rbPsychiatricHistoryYes' name='rbPsychiatricHistory' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbPsychiatricHistoryNo' name='rbPsychiatricHistory' className='add-only' value='No' /> No
                </p>

                <table>
                    <tr>
                        <td className='w-500'><span className='eleHeader'>Current Psychiatrist/Therapist:</span></td>
                        <td className='w-250'><span className='eleHeader'>Telephone Number:</span></td>
                    </tr>
                    <tr>
                        <td className='w-500'><input type='text' id='txtCurrentPsychiatrist' name='txtCurrentPsychiatrist' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtTelephoneNumber' name='txtTelephoneNumber' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>What word(s) would describe how you feel about treatment (attitude)? </span>
                    <textarea id='txtWordsHowYouFeel' name='txtWordsHowYouFeel' className='add-only' ></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>How old were you when you first saw someone related to behavioral health? Why? </span>
                    <textarea id='txtFirstSawBehavioralHealth' name='txtFirstSawBehavioralHealth' className='add-only' ></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>What services worked for you? Why? </span>
                    <textarea id='txtWhatServicesWorked' name='txtWhatServicesWorked' className='add-only' ></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>What services didn&#39;t work for you? Why? </span>
                    <textarea id='txtWhatServicesDidNotWork' name='txtWhatServicesDidNotWork' className='add-only' ></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>How many times have you been hospitalized (behavioral health - substance abuse or psychiatric) in the past 12 months? </span></td>
                        <td className='w-375'><span className='eleHeader'>How many times have you been hospitalized (behavioral health - substance abuse or psychiatric) in your life? </span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtHowManyTimesHospitalized12Months' name='txtHowManyTimesHospitalized12Months' className='add-only w-350 custom-add-only' /></td>
                        <td className='w-375'><input type='text' id='txtHowManyTimesHospitalizedInLife' name='txtHowManyTimesHospitalizedInLife' className='add-only w-350 custom-add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'># Hospitalizations - Reasons for hospitalizations - Dates: </span>
                    <textarea id='txtHospitalization' name='txtHospitalization' className='add-only' ></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>Family Mental Health History (attempted suicides, completed suicides, siblings or parents diagnosed with mental illness): </span>
                    <textarea id='txtFamilyMentalHealthHistory' name='txtFamilyMentalHealthHistory' className='add-only' ></textarea>
                </p>

                <p className='w-750'><h3>Medical History</h3></p>
                <p className='w-750'><input type='checkbox' id='cbMedicalHistory' name='cbMedicalHistory' className='add-only' value='MedicalHistory' /> No significant medical history/generally healthy physically <span className='small'>(Skip to the next section.)</span></p>


                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Do you take medications </span><span className='small'>(includes over-the-counter, vitamins, and herbal supplements)?</span></td>
                    </tr>
                    <tr>
                        <td className=''><input type='radio' id='rbDoYouTakeMedicationsYes' name='rbDoYouTakeMedications' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbDoYouTakeMedicationsNo' name='rbDoYouTakeMedications' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>How many days per week do you take your medications?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtDaysPerWeekYouTakeMedication' name='txtDaysPerWeekYouTakeMedication' className='add-only' /></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-500'><span className='eleHeader'>Primary Care Physician:</span></td>
                        <td className='w-250'><span className='eleHeader'>Date last seen?</span></td>
                    </tr>
                    <tr>
                        <td className='w-500'><input type='text' id='txtPrimaryCarePhysician' name='txtPrimaryCarePhysician' className='add-only' /></td>
                        <td className='w-250'><input type='date' id='txtPrimaryCarePhysicianLastSeen' name='txtPrimaryCarePhysicianLastSeen' className='add-only' /></td>
                    </tr>


                    <tr>
                        <td className='w-375'><span className='eleHeader'>Primary Care Physician Phone Number:</span></td>
                        <td className='w-375'><span className='eleHeader'>How long has this been your doctor?</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtPrimaryCarePhysicianPhoneNumber' name='txtPrimaryCarePhysicianPhoneNumber' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtHowLongBeenYourDoctor' name='txtHowLongBeenYourDoctor' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><b>Medication Name: </b><span className='small'>(include XL, XR, CR, SR, etc. as applicable if it&#39;s a part of the name)</span></p>
                <p className='w-750'><b>Dosage: </b><span className='small'>(include dose and mg, IU, mcg, etc.)</span></p>

                <table>
                    <tr>
                        <td className='w-350'><span className='eleHeader'>1. Medication Name</span></td>
                        <td className='w-250'><span className='eleHeader'>Dosage</span></td>
                        <td className='w-150'><span className='eleHeader'>Route</span></td>
                    </tr>
                    <tr>
                        <td className='w-350'><input type='text' id='txtMedicationName_1' name='txtMedicationName_1' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtDosage_1' name='txtDosage_1' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtRoute_1' name='txtRoute_1' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Frequency</span></td>
                        <td className='w-250'><span className='eleHeader'>Indicated for:</span></td>
                        <td className='w-250'><span className='eleHeader'>Prescribing Physician/ Pharmacy:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='text' id='txtFrequency_1' name='txtFrequency_1' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtIndicatedFor_1' name='txtIndicatedFor_1' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtPrescribing_1' name='txtPrescribing_1' className='add-only' /></td>
                    </tr>


                    <tr>
                        <td className='w-350'><span className='eleHeader'>2. Medication Name</span></td>
                        <td className='w-250'><span className='eleHeader'>Dosage</span></td>
                        <td className='w-150'><span className='eleHeader'>Route</span></td>
                    </tr>
                    <tr>
                        <td className='w-350'><input type='text' id='txtMedicationName_2' name='txtMedicationName_2' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtDosage_2' name='txtDosage_2' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtRoute_2' name='txtRoute_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Frequency</span></td>
                        <td className='w-250'><span className='eleHeader'>Indicated for:</span></td>
                        <td className='w-250'><span className='eleHeader'>Prescribing Physician/ Pharmacy:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='text' id='txtFrequency_2' name='txtFrequency_2' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtIndicatedFor_2' name='txtIndicatedFor_2' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtPrescribing_2' name='txtPrescribing_2' className='add-only' /></td>
                    </tr>


                    <tr>
                        <td className='w-350'><span className='eleHeader'>3. Medication Name</span></td>
                        <td className='w-250'><span className='eleHeader'>Dosage</span></td>
                        <td className='w-150'><span className='eleHeader'>Route</span></td>
                    </tr>
                    <tr>
                        <td className='w-350'><input type='text' id='txtMedicationName_3' name='txtMedicationName_3' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtDosage_3' name='txtDosage_3' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtRoute_3' name='txtRoute_3' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Frequency</span></td>
                        <td className='w-250'><span className='eleHeader'>Indicated for:</span></td>
                        <td className='w-250'><span className='eleHeader'>Prescribing Physician/ Pharmacy:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='text' id='txtFrequency_3' name='txtFrequency_3' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtIndicatedFor_3' name='txtIndicatedFor_3' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtPrescribing_3' name='txtPrescribing_3' className='add-only' /></td>
                    </tr>


                    <tr>
                        <td className='w-350'><span className='eleHeader'>4. Medication Name</span></td>
                        <td className='w-250'><span className='eleHeader'>Dosage</span></td>
                        <td className='w-150'><span className='eleHeader'>Route</span></td>
                    </tr>
                    <tr>
                        <td className='w-350'><input type='text' id='txtMedicationName_4' name='txtMedicationName_4' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtDosage_4' name='txtDosage_4' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtRoute_4' name='txtRoute_4' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Frequency</span></td>
                        <td className='w-250'><span className='eleHeader'>Indicated for:</span></td>
                        <td className='w-250'><span className='eleHeader'>Prescribing Physician/ Pharmacy:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='text' id='txtFrequency_4' name='txtFrequency_4' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtIndicatedFor_4' name='txtIndicatedFor_4' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtPrescribing_4' name='txtPrescribing_4' className='add-only' /></td>
                    </tr>


                    <tr>
                        <td className='w-350'><span className='eleHeader'>5. Medication Name</span></td>
                        <td className='w-250'><span className='eleHeader'>Dosage</span></td>
                        <td className='w-150'><span className='eleHeader'>Route</span></td>
                    </tr>
                    <tr>
                        <td className='w-350'><input type='text' id='txtMedicationName_5' name='txtMedicationName_5' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtDosage_5' name='txtDosage_5' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtRoute_5' name='txtRoute_5' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Frequency</span></td>
                        <td className='w-250'><span className='eleHeader'>Indicated for:</span></td>
                        <td className='w-250'><span className='eleHeader'>Prescribing Physician/ Pharmacy:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='text' id='txtFrequency_5' name='txtFrequency_5' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtIndicatedFor_5' name='txtIndicatedFor_5' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtPrescribing_5' name='txtPrescribing_5' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><input type='checkbox' id='cbAdditionalSpace' name='cbAdditionalSpace' className='add-only' value='AdditionalSpace' />
                    Additional Space was needed. Please see the full Medication Profile Page attached.
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Allergies</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbAllergiesNone' name='cbAllergiesNone' className='add-only' value='None' /> None</td>
                        <td className='w-187'><input type='checkbox' id='cbAllergiesAirborne' name='cbAllergiesAirborne' className='add-only' value='Airborne' /> Airborne</td>
                        <td className='w-187'><input type='checkbox' id='cbAllergiesFood' name='cbAllergiesFood' className='add-only' value='Food' /> Food</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbAllergiesMedication' name='cbAllergiesMedication' className='add-only' value='Medication' /> Medication - Specify:
                            <input type='text' id='txtAllergiesMedicationSpecify' name='txtAllergiesMedicationSpecify' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbAllergiesOther' name='cbAllergiesOther' className='add-only' value='Other' /> Other - specify:
                            <input type='text' id='txtAllergiesOtherSpecify' name='txtAllergiesOtherSpecify' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Pregnant</span></td>
                        <td className='w-375'><span className='eleHeader'>Dental Problems</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbPregnantYes' name='rbPregnant' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbPregnantNo' name='rbPregnant' className='add-only' value='No' /> No

                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbDentalProblemsYes' name='rbDentalProblems' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbDentalProblemsNo' name='rbDentalProblems' className='add-only' value='No' /> No
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Disabilities</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbDisabilitiesNone' name='cbDisabilitiesNone' className='add-only' value='None' /> None</td>
                        <td className='w-187'><input type='checkbox' id='cbDisabilitiesHearingImpairment' name='cbDisabilitiesHearingImpairment' className='add-only' value='HearingImpairment' /> Hearing Impairment</td>
                        <td className='w-187'><input type='checkbox' id='cbDisabilitiesVisualImpairment' name='cbDisabilitiesVisualImpairment' className='add-only' value='VisualImpairment' /> Visual Impairment</td>
                        <td className='w-187'><input type='checkbox' id='cbDisabilitiesVisualAmbulation' name='cbDisabilitiesVisualAmbulation' className='add-only' value='Ambulation' /> Ambulation</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbDisabilitiesOther' name='cbDisabilitiesOther' className='add-only' value='Other' /> Other - specify:
                            <input type='text' id='txtDisabilitiesOtherSpecify' name='txtDisabilitiesOtherSpecify' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'><span className='eleHeader'>History of head injury</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbHeadInjuryHistoryNo' name='rbHeadInjuryHistory' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbHeadInjuryHistoryYes' name='rbHeadInjuryHistory' className='add-only' value='Yes' /> Yes
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><b> If “yes”, explain: </b>
                            <input type='text' id='txtDisabilitiesOtherSpecify' name='txtDisabilitiesOtherSpecify' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>

                </table>

                <p className='w-750'><span className='eleHeader'>Illnesses </span><span className='small'>(include significant medical history, medical hospitalizations, treatment and medications, response to treatment):</span>
                    <textarea id='txtIllnesses' name='txtIllnesses' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>Current Living Situation:</span>
                    <textarea id='txtCurrentLivingSituation' name='txtCurrentLivingSituation' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>Family Relationships/Constellation/Support System/Peer Group:</span>
                    <textarea id='txtFamilyRelationship' name='txtFamilyRelationship' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Victim of Sexual or Physical Abuse?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbVictimSexualOrPhysicalAbuseNo' name='rbVictimSexualOrPhysicalAbuse' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbVictimSexualOrPhysicalAbuseYes' name='rbVictimSexualOrPhysicalAbuse' className='add-only' value='Yes' /> Yes
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><b> Details: </b>
                            <input type='text' id='txtVictimSexualOrPhysicalAbuseDetails' name='txtVictimSexualOrPhysicalAbuseDetails' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Any DSS/CPS involvement within the past 12 months?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbAnyDssCpsInvolvementInPastYearNo' name='rbAnyDssCpsInvolvementInPastYear' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbAnyDssCpsInvolvementInPastYearYes' name='rbAnyDssCpsInvolvementInPastYear' className='add-only' value='Yes' /> Yes
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><b> Details: </b>
                            <input type='text' id='txtAnyDssCpsInvolvementInPastYearDetails' name='txtAnyDssCpsInvolvementInPastYearDetails' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Gang involvement in the past 12 months?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbGangInvolvementInPastYearNo' name='rbGangInvolvementInPastYear' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbGangInvolvementInPastYearYes' name='rbGangInvolvementInPastYear' className='add-only' value='Yes' /> Yes
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><b> Details: </b>
                            <input type='text' id='txtGangInvolvementInPastYearDetails' name='txtGangInvolvementInPastYearDetails' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>History of fire setting in the past 12 months?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbHistoryOfSettingFireInPastYearNo' name='rbHistoryOfSettingFireInPastYear' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbHistoryOfSettingFireInPastYearYes' name='rbHistoryOfSettingFireInPastYear' className='add-only' value='Yes' /> Yes
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><b> Details: </b>
                            <input type='text' id='txtHistoryOfSettingFireInPastYearDetails' name='txtHistoryOfSettingFireInPastYearDetails' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>History of criminal justice involvement in the past 12 months?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbHistoryOfCriminalJusticeInvolvementNo' name='rbHistoryOfCriminalJusticeInvolvement' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbHistoryOfCriminalJusticeInvolvementYes' name='rbHistoryOfCriminalJusticeInvolvement' className='add-only' value='Yes' /> Yes
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><b> Details: </b>
                            <input type='text' id='txtHistoryOfCriminalJusticeInvolvementDetails' name='txtHistoryOfCriminalJusticeInvolvementDetails' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Old charges/convictions/ Time Served?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbOldChargesTimeServedNo' name='rbOldChargesTimeServed' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbOldChargesTimeServedYes' name='rbOldChargesTimeServed' className='add-only' value='Yes' /> Yes
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><b> Details: </b>
                            <input type='text' id='txtOldChargesTimeServedDetails' name='txtOldChargesTimeServedDetails' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Are you currently on probation?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbCurrentlyOnProbationNo' name='rbCurrentlyOnProbation' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbCurrentlyOnProbationYes' name='rbCurrentlyOnProbation' className='add-only' value='Yes' /> Yes
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><b> Details: </b>
                            <input type='text' id='txtCurrentlyOnProbationDetails' name='txtCurrentlyOnProbationDetails' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><b> Name of court counselor or parole officer? </b>
                            <input type='text' id='txtCurrentlyOnProbationNameOfCourt' name='txtCurrentlyOnProbationNameOfCourt' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Any history of sexually inappropriate/aggressive behavior?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbHistoryOfSexuallyInappropriateNo' name='rbHistoryOfSexuallyInappropriate' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbHistoryOfSexuallyInappropriateYes' name='rbHistoryOfSexuallyInappropriate' className='add-only' value='Yes' /> Yes
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><b> Details: </b>
                            <input type='text' id='txtHistoryOfSexuallyInappropriateDetails' name='txtHistoryOfSexuallyInappropriateDetails' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Are you adjudicated?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbAreYouAdjudicatedNo' name='rbAreYouAdjudicated' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbAreYouAdjudicatedYes' name='rbAreYouAdjudicated' className='add-only' value='Yes' /> Yes
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><b> Details: </b>
                            <input type='text' id='txtAreYouAdjudicatedDetails' name='txtAreYouAdjudicatedDetails' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Do you, yourself, have a guardian?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbDoYouHaveGuardianNo' name='rbDoYouHaveGuardian' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbDoYouHaveGuardianYes' name='rbDoYouHaveGuardian' className='add-only' value='Yes' /> Yes
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><b> Details: </b>
                            <input type='text' id='txtDoYouHaveGuardianDetails' name='txtDoYouHaveGuardianDetails' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Do you have legal custody of your children?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbHaveLegalCustodyOfYourChildrenNotApplicable' name='rbHaveLegalCustodyOfYourChildren' className='add-only' value='NotApplicable' /> Not Applicable &nbsp;
                            <input type='radio' id='rbHaveLegalCustodyOfYourChildrenNo' name='rbHaveLegalCustodyOfYourChildren' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbHaveLegalCustodyOfYourChildrenYes' name='rbHaveLegalCustodyOfYourChildren' className='add-only' value='Yes' /> Yes
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><b> Details: </b>
                            <input type='text' id='txtHaveLegalCustodyOfYourChildrenDetails' name='txtHaveLegalCustodyOfYourChildrenDetails' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Do you have documentation of legal custody?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbDocumentationOfLegalCustodyNo' name='rbDocumentationOfLegalCustody' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbDocumentationOfLegalCustodyYes' name='rbDocumentationOfLegalCustody' className='add-only' value='Yes' /> Yes
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><b> Details: </b>
                            <input type='text' id='txtDocumentationOfLegalCustodyDetails' name='txtDocumentationOfLegalCustodyDetails' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Are you receiving any benefits</span><span className='small'>(i.e. SSI, child support, disability income)?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbCurrentlyOnProbationNo' name='rbCurrentlyOnProbation' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbCurrentlyOnProbationYes' name='rbCurrentlyOnProbation' className='add-only' value='Yes' /> Yes
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><b> Details: </b>
                            <input type='text' id='txtCurrentlyOnProbationDetails' name='txtCurrentlyOnProbationDetails' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Ethnic, Cultural, Language, Social Factors:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtEthnicFactors' name='txtEthnicFactors' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Leisure/Recreation:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtLeisureRecreation' name='txtLeisureRecreation' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Military Service History</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbMilitaryServiceHistoryNo' name='rbMilitaryServiceHistory' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbMilitaryServiceHistoryYes' name='rbMilitaryServiceHistory' className='add-only' value='Yes' /> Yes
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><b> Details: </b>
                            <input type='text' id='txtMilitaryServiceHistoryDetails' name='txtMilitaryServiceHistoryDetails' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Spiritual/Religious Affiliation/Preferences:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtSpiritualPreferences' name='txtSpiritualPreferences' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Childhood History </span><span className='small'>(i.e. stability, domestic environment, etc.):</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtChildhoodHistory' name='txtChildhoodHistory' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Employment History:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtEmploymentHistory' name='txtEmploymentHistory' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>Education:</b></td>
                    </tr>

                    <tr>
                        <td className='w-375'><span className='eleHeader'>What school are you in?</span></td>
                        <td className='w-375'><span className='eleHeader'>What is your grade level?</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtWhatSchoolAreYouIn' name='txtWhatSchoolAreYouIn' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtWhatIsYourGradeLevel' name='txtWhatIsYourGradeLevel' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Do you have an IEP?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbDoYouHaveIepNo' name='rbDoYouHaveIep' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbDoYouHaveIepYes' name='rbDoYouHaveIep' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbDoYouHaveIepNotApplicable' name='rbDoYouHaveIep' className='add-only' value='NotApplicable' /> Not Applicable
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Any suspensions?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbAnySuspensionsNotApplicable' name='rbAnySuspensions' className='add-only' value='NotApplicable' /> Not Applicable &nbsp;
                            <input type='radio' id='rbAnySuspensionsNo' name='rbAnySuspensions' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbAnySuspensionsYes' name='rbAnySuspensions' className='add-only' value='Yes' /> Yes
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>Details:</b> <input type='text' id='txtAnySuspensionsDetails' name='txtAnySuspensionsDetails' className='add-only w-350 custom-add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Any expulsions?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbAnyExpulsionsNotApplicable' name='rbAnyExpulsions' className='add-only' value='NotApplicable' /> Not Applicable &nbsp;
                            <input type='radio' id='rbAnyExpulsionsNo' name='rbAnyExpulsions' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbAnyExpulsionsYes' name='rbAnyExpulsions' className='add-only' value='Yes' /> Yes
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>Details:</b>
                            <input type='text' id='txtAnyExpulsionsDetails' name='txtAnyExpulsionsDetails' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h3>Mental Status Examination:</h3></p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Appearance/Hygiene</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbAppropriate' name='cbAppropriate' className='add-only' value='Appropriate' /> Appropriate</td>
                        <td className='w-187'><input type='checkbox' id='cbRelaxedPosture' name='cbRelaxedPosture' className='add-only' value='RelaxedPosture' /> Relaxed posture</td>
                        <td className='w-187'><input type='checkbox' id='cbTensePostur' name='cbTensePostur' className='add-only' value='TensePostur' /> Tense Postur</td>
                        <td className='w-187'><input type='checkbox' id='cbUnkempt' name='cbUnkempt' className='add-only' value='Unkempt' /> Unkempt</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbThin' name='cbThin' className='add-only' value='Thin' /> Thin</td>
                        <td className='w-187'><input type='checkbox' id='cbOverweight' name='cbOverweight' className='add-only' value='Overweight' /> Overweight</td>
                        <td className='w-187'><input type='checkbox' id='cbTattoo' name='cbTattoo' className='add-only' value='Tattoo' /> Tattoo</td>
                        <td className='w-187'><input type='checkbox' id='cbPiercing' name='cbPiercing' className='add-only' value='Piercing' /> Piercing</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbInappropriate' name='cbInappropriate' className='add-only' value='Inappropriate' /> Inappropriate</td>
                        <td className='w-500'><input type='checkbox' id='cbWellDressed' name='cbWellDressed' className='add-only' value='WellDressed' /> Well dressed/Well Nourished/ Well Groomed</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbAppearanceHygieneOther' name='cbAppearanceHygieneOther' className='add-only' value='Other' /> Other:
                            <input type='text' id='txtAppearanceHygiene' name='txtAppearanceHygiene' className='add-only w-350 custom-add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Behavior/Motor</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbApathetic' name='cbApathetic' className='add-only' value='Apathetic' /> Apathetic</td>
                        <td className='w-187'><input type='checkbox' id='cbTense' name='cbTense' className='add-only' value='Tense' /> Tense</td>
                        <td className='w-187'><input type='checkbox' id='cbAgitated' name='cbAgitated' className='add-only' value='Agitated' /> Agitated</td>
                        <td className='w-187'><input type='checkbox' id='cbHostile' name='cbHostile' className='add-only' value='Hostile' /> Hostile</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbHyperactive' name='cbHyperactive' className='add-only' value='Hyperactive' /> Hyperactive</td>
                        <td className='w-187'><input type='checkbox' id='cbImpulsive' name='cbImpulsive' className='add-only' value='Impulsive' /> Impulsive</td>
                        <td className='w-187'><input type='checkbox' id='cbCombative' name='cbCombative' className='add-only' value='Combative' /> Combative</td>
                        <td className='w-187'><input type='checkbox' id='cbDefensive' name='cbDefensive' className='add-only' value='Defensive' /> Defensive</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbEvasive' name='cbEvasive' className='add-only' value='Evasive' /> Evasive</td>
                        <td className='w-187'><input type='checkbox' id='cbMannerisms' name='cbMannerisms' className='add-only' value='Mannerisms' /> Mannerisms</td>
                        <td className='w-187'><input type='checkbox' id='cbTics' name='cbTics' className='add-only' value='Tics' /> Tics</td>
                        <td className='w-187'><input type='checkbox' id='cbGestures' name='cbGestures' className='add-only' value='Gestures' /> Gestures</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbTremor' name='cbTremor' className='add-only' value='Tremor' /> Tremor</td>
                        <td className='w-187'><input type='checkbox' id='cbAtaxic' name='cbAtaxic' className='add-only' value='Ataxic' /> Ataxic</td>
                        <td className='w-187'><input type='checkbox' id='cbParkinsons' name='cbParkinsons' className='add-only' value='Parkinsons' /> Parkinson&#39;s</td>
                        <td className='w-187'><input type='checkbox' id='cbTardiveDsykinesia' name='cbTardiveDsykinesia' className='add-only' value='TardiveDsykinesia' /> Tardive Dsykinesia</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbAppropriateRrelaxed' name='cbAppropriateRrelaxed' className='add-only' value='AppropriateRrelaxed' /> Appropriate, relaxed</td>
                        <td className='w-375'><input type='checkbox' id='cbAbnormalInvoluntaryMovements' name='cbAbnormalInvoluntaryMovements' className='add-only' value='AbnormalInvoluntaryMovements' /> Abnormal Involuntary Movements</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbBehaviorMotorOther' name='cbBehaviorMotorOther' className='add-only' value='Other' /> Other:
                            <input type='text' id='txtBehaviorMotor' name='txtBehaviorMotor' className='add-only w-350 custom-add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><h3>Speech:</h3></p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Volume</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='radio' id='rbVolumeNormal' name='rbVolume' className='add-only' value='Normal' /> Normal</td>
                        <td className='w-187'><input type='radio' id='rbVolumeLoud' name='rbVolume' className='add-only' value='Loud' /> Loud</td>
                        <td className='w-187'><input type='radio' id='rbVolumeQuiet' name='rbVolume' className='add-only' value='Quiet' /> Quiet</td>
                        <td className='w-187'><input type='radio' id='rbVolumeVaried' name='rbVolume' className='add-only' value='Varied' /> Varied</td>
                    </tr>


                    <tr>
                        <td className='w-750'><span className='eleHeader'>Tone</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='radio' id='rbToneAppropriate' name='rbTone' className='add-only' value='Appropriate' /> Appropriate</td>
                        <td className='w-187'><input type='radio' id='rbToneLoud' name='rbTone' className='add-only' value='Loud' /> Loud</td>
                        <td className='w-187'><input type='radio' id='rbToneMonotone' name='rbTone' className='add-only' value='Monotone' /> Monotone</td>
                        <td className='w-187'><input type='radio' id='rbToneStuttered' name='rbTone' className='add-only' value='Stuttered' /> Stuttered</td>
                    </tr>


                    <tr>
                        <td className='w-750'><span className='eleHeader'>Vocabulary</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='radio' id='rbVocabularyBelowAvg' name='rbVocabulary' className='add-only' value='BelowAvg' /> Below Avg</td>
                        <td className='w-187'><input type='radio' id='rbVocabularyAverage' name='rbVocabulary' className='add-only' value='Average' /> Average</td>
                        <td className='w-187'><input type='radio' id='rbVocabularyAboveAvg' name='rbVocabulary' className='add-only' value='AboveAvg' /> Above Avg</td>
                    </tr>


                    <tr>
                        <td className='w-750'><span className='eleHeader'>Rate</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='radio' id='rbRateNormal' name='rbRate' className='add-only' value='Normal' /> Normal</td>
                        <td className='w-187'><input type='radio' id='rbRateRapid' name='rbRate' className='add-only' value='Rapid' /> Rapid</td>
                        <td className='w-187'><input type='radio' id='rbRatePressures' name='rbRate' className='add-only' value='Pressures' /> Pressures</td>
                        <td className='w-187'><input type='radio' id='rbRateSlow' name='rbRate' className='add-only' value='Slow' /> Slow</td>
                    </tr>


                    <tr>
                        <td className='w-750'><span className='eleHeader'>Rhythm</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='radio' id='rbRhythmNormal' name='rbRhythm' className='add-only' value='Normal' /> Normal</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='radio' id='rbRhythmOther' name='rbRhythm' className='add-only' value='Other' /> Other:
                            <input type='text' id='txtRhythmOther' name='txtRhythmOther' className='add-only w-350 custom-add-only' /></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Mood</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbCalm' name='cbCalm' className='add-only' value='Calm' /> Calm</td>
                        <td className='w-187'><input type='checkbox' id='cbDsythymic' name='cbDsythymic' className='add-only' value='Dsythymic' /> Dsythymic</td>
                        <td className='w-187'><input type='checkbox' id='cbMoodApathetic' name='cbMoodApathetic' className='add-only' value='Apathetic' /> Apathetic</td>
                        <td className='w-187'><input type='checkbox' id='cbDepressed' name='cbDepressed' className='add-only' value='Depressed' /> Depressed</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbEuphoric' name='cbEuphoric' className='add-only' value='Euphoric' /> Euphoric</td>
                        <td className='w-187'><input type='checkbox' id='cbDespairing' name='cbDespairing' className='add-only' value='Despairing' /> Despairing</td>
                        <td className='w-187'><input type='checkbox' id='cbGuilty' name='cbGuilty' className='add-only' value='Guilty' /> Guilty</td>
                        <td className='w-187'><input type='checkbox' id='cbAnxious' name='cbAnxious' className='add-only' value='Anxious' /> Anxious</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbAngry' name='cbAngry' className='add-only' value='Angry' /> Angry</td>
                        <td className='w-187'><input type='checkbox' id='cbIrritable' name='cbIrritable' className='add-only' value='Irritable' /> Irritable</td>
                        <td className='w-187'><input type='checkbox' id='cbNeutral' name='cbNeutral' className='add-only' value='Neutral' /> Neutral</td>
                        <td className='w-187'><input type='checkbox' id='cbTerrified' name='cbTerrified' className='add-only' value='Terrified' /> Terrified</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbFearful' name='cbFearful' className='add-only' value='Fearful' /> Fearful</td>
                        <td className='w-187'><input type='checkbox' id='cbElated' name='cbElated' className='add-only' value='Elated' /> Elated</td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Affect</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbConstricted' name='cbConstricted' className='add-only' value='Constricted' /> Constricted</td>
                        <td className='w-187'><input type='checkbox' id='cbBlunted' name='cbBlunted' className='add-only' value='Blunted' /> Blunted</td>
                        <td className='w-187'><input type='checkbox' id='cbFlat' name='cbFlat' className='add-only' value='Flat' /> Flat</td>
                        <td className='w-187'><input type='checkbox' id='cbLabile' name='cbLabile' className='add-only' value='Labile' /> Labile</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbAppropriateThoughts' name='cbAppropriateThoughts' className='add-only' value='AppropriateThoughts' /> Full range, appropriate thoughts, normal intensity</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Attitude</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbCooperative' name='cbCooperative' className='add-only' value='Cooperative' /> Cooperative</td>
                        <td className='w-187'><input type='checkbox' id='cbGuarded' name='cbGuarded' className='add-only' value='Guarded' /> Guarded</td>
                        <td className='w-187'><input type='checkbox' id='cbParanoid' name='cbParanoid' className='add-only' value='Paranoid' /> Paranoid</td>
                        <td className='w-187'><input type='checkbox' id='cbIndifferent' name='cbIndifferent' className='add-only' value='Indifferent' /> Indifferent</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbDemanding' name='cbDemanding' className='add-only' value='Demanding' /> Demanding</td>
                        <td className='w-187'><input type='checkbox' id='cbEntitled' name='cbEntitled' className='add-only' value='Entitled' /> Entitled</td>
                        <td className='w-187'><input type='checkbox' id='cbPassiveAggressive' name='cbPassiveAggressive' className='add-only' value='PassiveAggressive' /> Passive-Aggressive</td>
                        <td className='w-187'><input type='checkbox' id='cbSuspicious' name='cbSuspicious' className='add-only' value='Suspicious' /> Suspicious</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbManipulative' name='cbManipulative' className='add-only' value='Manipulative' /> Manipulative</td>
                        <td className='w-187'><input type='checkbox' id='cbPlayful' name='cbPlayful' className='add-only' value='Playful' /> Playful</td>
                        <td className='w-187'><input type='checkbox' id='cbResistive' name='cbResistive' className='add-only' value='Resistive' /> Resistive</td>
                    </tr>

                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Thought Process</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbCircumstantial' name='cbCircumstantial' className='add-only' value='Circumstantial' /> Circumstantial</td>
                        <td className='w-187'><input type='checkbox' id='cbTangential' name='cbTangential' className='add-only' value='Tangential' /> Tangential</td>
                        <td className='w-187'><input type='checkbox' id='cbFlightIdeas' name='cbFlightIdeas' className='add-only' value='FlightIdeas' /> Flight of Ideas</td>
                        <td className='w-187'><input type='checkbox' id='cbPerseverative' name='cbPerseverative' className='add-only' value='Perseverative' /> Perseverative</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbConfabulation' name='cbConfabulation' className='add-only' value='Confabulation' /> Confabulation</td>
                        <td className='w-187'><input type='checkbox' id='cbDistracted' name='cbDistracted' className='add-only' value='Distracted' /> Distracted</td>
                        <td className='w-187'><input type='checkbox' id='cbIncoherent' name='cbIncoherent' className='add-only' value='Incoherent' /> Incoherent</td>
                        <td className='w-187'><input type='checkbox' id='cbConcrete' name='cbConcrete' className='add-only' value='Concrete' /> Concrete</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbOrganizedRelevant' name='cbOrganizedRelevant' className='add-only' value='OrganizedRelevant' /> Organized, relevant</td>
                        <td className='w-500'><input type='checkbox' id='cbLooseAssociationGoalDirected' name='cbLooseAssociationGoalDirected' className='add-only' value='LooseAssociationGoalDirected' /> Loose Association and Goal Directed</td>

                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Perceptions</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='radio' id='rbPerceptionsNoDistortion' name='rbPerceptions' className='add-only' value='NoDistortion' /> No Distortion</td>
                        <td className='w-187'><input type='radio' id='rbPerceptionsDeRealization' name='rbPerceptions' className='add-only' value='DeRealization' /> De-realization</td>
                        <td className='w-187'><input type='radio' id='rbPerceptionsDepersonalization' name='rbPerceptions' className='add-only' value='Depersonalization' /> Depersonalization</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Hallucinations</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='radio' id='rbHallucinationsAuditory' name='rbHallucinations' className='add-only' value='Auditory' /> Auditory</td>
                        <td className='w-187'><input type='radio' id='rbHallucinationsVisual' name='rbHallucinations' className='add-only' value='Visual' /> Visual</td>
                        <td className='w-187'><input type='radio' id='rbHallucinationsNone' name='rbHallucinations' className='add-only' value='None' /> None</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Thought Content</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbWnl' name='cbWnl' className='add-only' value='Wnl' /> WNL</td>
                        <td className='w-187'><input type='checkbox' id='cbPreoccupations' name='cbPreoccupations' className='add-only' value='Preoccupations' /> Preoccupations</td>
                        <td className='w-187'><input type='checkbox' id='cbObsessions' name='cbObsessions' className='add-only' value='Obsessions' /> Obsessions</td>
                        <td className='w-187'><input type='checkbox' id='cbCompulsions' name='cbCompulsions' className='add-only' value='Compulsions' /> Compulsions</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbParanoid' name='cbParanoid' className='add-only' value='Paranoid' /> Paranoid</td>
                        <td className='w-187'><input type='checkbox' id='cbDelusions' name='cbDelusions' className='add-only' value='Delusions' /> Delusions</td>
                        <td className='w-187'><input type='checkbox' id='cbPhobias' name='cbPhobias' className='add-only' value='Phobias' /> Phobias</td>
                        <td className='w-187'><input type='checkbox' id='cbGrandiosity' name='cbGrandiosity' className='add-only' value='Grandiosity' /> Grandiosity</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbDepressive' name='cbDepressive' className='add-only' value='Depressive' /> Depressive</td>
                        <td className='w-187'><input type='checkbox' id='cbThoughtInsertion' name='cbThoughtInsertion' className='add-only' value='ThoughtInsertion' /> Thought Insertion</td>
                        <td className='w-187'><input type='checkbox' id='cbThoughtBroadcasting' name='cbThoughtBroadcasting' className='add-only' value='ThoughtBroadcasting' /> Thought Broadcasting</td>
                        <td className='w-187'><input type='checkbox' id='cbFear' name='cbFear' className='add-only' value='Fear' /> Fear</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbSuicidal' name='cbSuicidal' className='add-only' value='Suicidal' /> Suicidal</td>
                        <td className='w-187'><input type='checkbox' id='cbHomicidal' name='cbHomicidal' className='add-only' value='Homicidal' /> Homicidal</td>
                        <td className='w-187'><input type='checkbox' id='cbIdeation' name='cbIdeation' className='add-only' value='Ideation' /> Ideation</td>
                        <td className='w-187'><input type='checkbox' id='cbPlan' name='cbPlan' className='add-only' value='Plan' /> Plan</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbIntent' name='cbIntent' className='add-only' value='Intent' /> Intent</td>
                        <td className='w-187'><input type='checkbox' id='cbNoRisk' name='cbNoRisk' className='add-only' value='NoRisk' /> No Risk</td>
                        <td className='w-375'><input type='checkbox' id='cbPovertyThoughtContent' name='cbPovertyThoughtContent' className='add-only' value='PovertyThoughtContent' /> Poverty of Thought Content</td>
                    </tr>
                </table>

                <p className='w-750'><h3>Cognitive:</h3></p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Orientation</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='radio' id='rbOrientationPerson' name='rbOrientation' className='add-only' value='Person' /> Person</td>
                        <td className='w-187'><input type='radio' id='rbOrientationPlace' name='rbOrientation' className='add-only' value='Place' /> Place</td>
                        <td className='w-187'><input type='radio' id='rbOrientationTime' name='rbOrientation' className='add-only' value='Time' /> Time</td>
                        <td className='w-187'><input type='radio' id='rbOrientationSituation' name='rbOrientation' className='add-only' value='Situation' /> Situation</td>
                    </tr>


                    <tr>
                        <td className='w-750'><span className='eleHeader'>Intellectual</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='radio' id='rbIntellectualBelowAvg' name='rbIntellectual' className='add-only' value='BelowAvg' /> Below Avg</td>
                        <td className='w-187'><input type='radio' id='rbIntellectualAverage' name='rbIntellectual' className='add-only' value='Average' /> Average</td>
                        <td className='w-187'><input type='radio' id='rbIntellectualAboveAvg' name='rbIntellectual' className='add-only' value='AboveAvg' /> Above Avg</td>
                    </tr>


                    <tr>
                        <td className='w-750'><span className='eleHeader'>Memory</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='radio' id='rbMemoryBelowAvg' name='rbMemory' className='add-only' value='BelowAvg' /> Below Avg</td>
                        <td className='w-187'><input type='radio' id='rbMemoryAverage' name='rbMemory' className='add-only' value='Average' /> Average</td>
                        <td className='w-187'><input type='radio' id='rbMemoryAboveAvg' name='rbMemory' className='add-only' value='AboveAvg' /> Above Avg</td>
                    </tr>


                    <tr>
                        <td className='w-750'><span className='eleHeader'>Concentration</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='radio' id='rbConcentrationGood' name='rbConcentration' className='add-only' value='Good' /> Good</td>
                        <td className='w-187'><input type='radio' id='rbConcentrationFair' name='rbConcentration' className='add-only' value='Fair' /> Fair</td>
                        <td className='w-187'><input type='radio' id='rbConcentrationPoor' name='rbConcentration' className='add-only' value='Poor' /> Poor</td>
                    </tr>


                    <tr>
                        <td className='w-750'><span className='eleHeader'>Insight</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='radio' id='rbInsightGood' name='rbInsight' className='add-only' value='Good' /> Good</td>
                        <td className='w-187'><input type='radio' id='rbInsightFair' name='rbInsight' className='add-only' value='Fair' /> Fair</td>
                        <td className='w-187'><input type='radio' id='rbInsightPoor' name='rbInsight' className='add-only' value='Poor' /> Poor</td>
                    </tr>


                    <tr>
                        <td className='w-750'><span className='eleHeader'>Judgment</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='radio' id='rbJudgmentGood' name='rbJudgment' className='add-only' value='Good' /> Good</td>
                        <td className='w-187'><input type='radio' id='rbJudgmentFair' name='rbJudgment' className='add-only' value='Fair' /> Fair</td>
                        <td className='w-187'><input type='radio' id='rbJudgmentPoor' name='rbJudgment' className='add-only' value='Poor' /> Poor</td>
                    </tr>
                </table>

                <p className='w-750'><h3>Substance Use and Abuse:</h3></p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>History of Substance Use or Abuse?</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='radio' id='rbHistoryOfSubstanceUseNo' name='rbHistoryOfSubstanceUse' className='add-only' value='No' /> No</td>
                        <td className='w-187'><input type='radio' id='rbHistoryOfSubstanceUseFairYes' name='rbHistoryOfSubstanceUse' className='add-only' value='Yes' /> Yes</td>
                    </tr>
                </table>
                
                <table>
                    <tr>
                        <td className='w-750'><h3><b>"Route" Key: &nbsp;&nbsp;</b></h3> <b>1 -</b> Oral &nbsp;&nbsp;  <b>2 -</b> Smoking &nbsp;&nbsp;  <b>3 -</b> Inhaled &nbsp;&nbsp;  <b>4 -</b> Inject &nbsp;&nbsp;  <b>5 -</b> Other</td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>Drug used: </b>Alcohol</td>
                    </tr>
                    <tr>
                        <td className='w-187'><span className='eleHeader'>Age of 1st use</span></td>
                        <td className='w-187'><span className='eleHeader'>Age of regular use</span></td>
                        <td className='w-187'><span className='eleHeader'>*Route of use</span></td>
                        <td className='w-187'><span className='eleHeader'>Age of peak use</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='text' id='txtAlcoholFirstUse' name='txtAlcoholFirstUse' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtAlcoholRegularUse' name='txtAlcoholRegularUse' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtAlcoholRouteOfUse' name='txtAlcoholRouteOfUse' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtAlcoholAgePeakUse' name='txtAlcoholAgePeakUse' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-600'><span className='eleHeader'>Current pattern of use</span></td>
                        <td className='w-150'><span className='eleHeader'>Date of last use</span></td>
                    </tr>
                    <tr>
                        <td className='w-600'><input type='text' id='txtAlcoholCurrentUsePattern' name='txtAlcoholCurrentUsePattern' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtAlcoholDateLastUse' name='txtAlcoholDateLastUse' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>Drug used: </b>Cocaine/Crack</td>
                    </tr>
                    <tr>
                        <td className='w-187'><span className='eleHeader'>Age of 1st use</span></td>
                        <td className='w-187'><span className='eleHeader'>Age of regular use</span></td>
                        <td className='w-187'><span className='eleHeader'>*Route of use</span></td>
                        <td className='w-187'><span className='eleHeader'>Age of peak use</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='text' id='txtCocaineFirstUse' name='txtCocaineFirstUse' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtCocaineRegularUse' name='txtCocaineRegularUse' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtCocaineRouteOfUse' name='txtCocaineRouteOfUse' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtCocaineAgePeakUse' name='txtCocaineAgePeakUse' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-600'><span className='eleHeader'>Current pattern of use</span></td>
                        <td className='w-150'><span className='eleHeader'>Date of last use</span></td>
                    </tr>
                    <tr>
                        <td className='w-600'><input type='text' id='txtCocaineCurrentUsePattern' name='txtCocaineCurrentUsePattern' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtCocaineDateLastUse' name='txtCocaineDateLastUse' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>Drug used: </b>Marijuana</td>
                    </tr>
                    <tr>
                        <td className='w-187'><span className='eleHeader'>Age of 1st use</span></td>
                        <td className='w-187'><span className='eleHeader'>Age of regular use</span></td>
                        <td className='w-187'><span className='eleHeader'>*Route of use</span></td>
                        <td className='w-187'><span className='eleHeader'>Age of peak use</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='text' id='txtMarijuanaFirstUse' name='txtMarijuanaFirstUse' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtMarijuanaRegularUse' name='txtMarijuanaRegularUse' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtMarijuanaRouteOfUse' name='txtMarijuanaRouteOfUse' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtMarijuanaAgePeakUse' name='txtMarijuanaAgePeakUse' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-600'><span className='eleHeader'>Current pattern of use</span></td>
                        <td className='w-150'><span className='eleHeader'>Date of last use</span></td>
                    </tr>
                    <tr>
                        <td className='w-600'><input type='text' id='txtMarijuanaCurrentUsePattern' name='txtMarijuanaCurrentUsePattern' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtMarijuanaDateLastUse' name='txtMarijuanaDateLastUse' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>Drug used: </b>Heroin</td>
                    </tr>
                    <tr>
                        <td className='w-187'><span className='eleHeader'>Age of 1st use</span></td>
                        <td className='w-187'><span className='eleHeader'>Age of regular use</span></td>
                        <td className='w-187'><span className='eleHeader'>*Route of use</span></td>
                        <td className='w-187'><span className='eleHeader'>Age of peak use</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='text' id='txtHeroinFirstUse' name='txtHeroinFirstUse' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtHeroinRegularUse' name='txtHeroinRegularUse' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtHeroinRouteOfUse' name='txtHeroinRouteOfUse' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtHeroinAgePeakUse' name='txtHeroinAgePeakUse' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-600'><span className='eleHeader'>Current pattern of use</span></td>
                        <td className='w-150'><span className='eleHeader'>Date of last use</span></td>
                    </tr>
                    <tr>
                        <td className='w-600'><input type='text' id='txtHeroinCurrentUsePattern' name='txtHeroinCurrentUsePattern' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtHeroinDateLastUse' name='txtHeroinDateLastUse' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>Drug used: </b>Non-RX Methadone</td>
                    </tr>
                    <tr>
                        <td className='w-187'><span className='eleHeader'>Age of 1st use</span></td>
                        <td className='w-187'><span className='eleHeader'>Age of regular use</span></td>
                        <td className='w-187'><span className='eleHeader'>*Route of use</span></td>
                        <td className='w-187'><span className='eleHeader'>Age of peak use</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='text' id='txtNonRxMethadoneFirstUse' name='txtNonRxMethadoneFirstUse' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtNonRxMethadoneRegularUse' name='txtNonRxMethadoneRegularUse' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtNonRxMethadoneRouteOfUse' name='txtNonRxMethadoneRouteOfUse' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtNonRxMethadoneAgePeakUse' name='txtNonRxMethadoneAgePeakUse' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-600'><span className='eleHeader'>Current pattern of use</span></td>
                        <td className='w-150'><span className='eleHeader'>Date of last use</span></td>
                    </tr>
                    <tr>
                        <td className='w-600'><input type='text' id='txtNonRxMethadoneCurrentUsePattern' name='txtNonRxMethadoneCurrentUsePattern' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtNonRxMethadoneDateLastUse' name='txtNonRxMethadoneDateLastUse' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>Drug used: </b>Other Opiates/Synthetic</td>
                    </tr>
                    <tr>
                        <td className='w-187'><span className='eleHeader'>Age of 1st use</span></td>
                        <td className='w-187'><span className='eleHeader'>Age of regular use</span></td>
                        <td className='w-187'><span className='eleHeader'>*Route of use</span></td>
                        <td className='w-187'><span className='eleHeader'>Age of peak use</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='text' id='txtOtherOpiatesSyntheticFirstUse' name='txtOtherOpiatesSyntheticFirstUse' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtOtherOpiatesSyntheticRegularUse' name='txtOtherOpiatesSyntheticRegularUse' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtOtherOpiatesSyntheticRouteOfUse' name='txtOtherOpiatesSyntheticRouteOfUse' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtOtherOpiatesSyntheticAgePeakUse' name='txtOtherOpiatesSyntheticAgePeakUse' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-600'><span className='eleHeader'>Current pattern of use</span></td>
                        <td className='w-150'><span className='eleHeader'>Date of last use</span></td>
                    </tr>
                    <tr>
                        <td className='w-600'><input type='text' id='txtOtherOpiatesSyntheticCurrentUsePattern' name='txtOtherOpiatesSyntheticCurrentUsePattern' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtOtherOpiatesSyntheticDateLastUse' name='txtOtherOpiatesSyntheticDateLastUse' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>Drug used: </b>PCP</td>
                    </tr>
                    <tr>
                        <td className='w-187'><span className='eleHeader'>Age of 1st use</span></td>
                        <td className='w-187'><span className='eleHeader'>Age of regular use</span></td>
                        <td className='w-187'><span className='eleHeader'>*Route of use</span></td>
                        <td className='w-187'><span className='eleHeader'>Age of peak use</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='text' id='txtPcpFirstUse' name='txtPcpFirstUse' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtPcpRegularUse' name='txtPcpRegularUse' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtPcpRouteOfUse' name='txtPcpRouteOfUse' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtPcpAgePeakUse' name='txtPcpAgePeakUse' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-600'><span className='eleHeader'>Current pattern of use</span></td>
                        <td className='w-150'><span className='eleHeader'>Date of last use</span></td>
                    </tr>
                    <tr>
                        <td className='w-600'><input type='text' id='txtPcpCurrentUsePattern' name='txtPcpCurrentUsePattern' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtPcpDateLastUse' name='txtPcpDateLastUse' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>Drug used: </b>Other Hallucinogen</td>
                    </tr>
                    <tr>
                        <td className='w-187'><span className='eleHeader'>Age of 1st use</span></td>
                        <td className='w-187'><span className='eleHeader'>Age of regular use</span></td>
                        <td className='w-187'><span className='eleHeader'>*Route of use</span></td>
                        <td className='w-187'><span className='eleHeader'>Age of peak use</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='text' id='txtOtherHallucinogenFirstUse' name='txtOtherHallucinogenFirstUse' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtOtherHallucinogenRegularUse' name='txtOtherHallucinogenRegularUse' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtOtherHallucinogenRouteOfUse' name='txtOtherHallucinogenRouteOfUse' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtOtherHallucinogenAgePeakUse' name='txtOtherHallucinogenAgePeakUse' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-600'><span className='eleHeader'>Current pattern of use</span></td>
                        <td className='w-150'><span className='eleHeader'>Date of last use</span></td>
                    </tr>
                    <tr>
                        <td className='w-600'><input type='text' id='txtOtherHallucinogenCurrentUsePattern' name='txtOtherHallucinogenCurrentUsePattern' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtOtherHallucinogenDateLastUse' name='txtOtherHallucinogenDateLastUse' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>Drug used: </b>Methamphetamine</td>
                    </tr>
                    <tr>
                        <td className='w-187'><span className='eleHeader'>Age of 1st use</span></td>
                        <td className='w-187'><span className='eleHeader'>Age of regular use</span></td>
                        <td className='w-187'><span className='eleHeader'>*Route of use</span></td>
                        <td className='w-187'><span className='eleHeader'>Age of peak use</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='text' id='txtMethamphetamineFirstUse' name='txtMethamphetamineFirstUse' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtMethamphetamineRegularUse' name='txtMethamphetamineRegularUse' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtMethamphetamineRouteOfUse' name='txtMethamphetamineRouteOfUse' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtMethamphetamineAgePeakUse' name='txtMethamphetamineAgePeakUse' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-600'><span className='eleHeader'>Current pattern of use</span></td>
                        <td className='w-150'><span className='eleHeader'>Date of last use</span></td>
                    </tr>
                    <tr>
                        <td className='w-600'><input type='text' id='txtMethamphetamineCurrentUsePattern' name='txtMethamphetamineCurrentUsePattern' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtMethamphetamineDateLastUse' name='txtMethamphetamineDateLastUse' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>Drug used: </b>Other Amphetamine</td>
                    </tr>
                    <tr>
                        <td className='w-187'><span className='eleHeader'>Age of 1st use</span></td>
                        <td className='w-187'><span className='eleHeader'>Age of regular use</span></td>
                        <td className='w-187'><span className='eleHeader'>*Route of use</span></td>
                        <td className='w-187'><span className='eleHeader'>Age of peak use</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='text' id='txtOtherAmphetamineFirstUse' name='txtOtherAmphetamineFirstUse' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtOtherAmphetamineRegularUse' name='txtOtherAmphetamineRegularUse' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtOtherAmphetamineRouteOfUse' name='txtOtherAmphetamineRouteOfUse' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtOtherAmphetamineAgePeakUse' name='txtOtherAmphetamineAgePeakUse' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-600'><span className='eleHeader'>Current pattern of use</span></td>
                        <td className='w-150'><span className='eleHeader'>Date of last use</span></td>
                    </tr>
                    <tr>
                        <td className='w-600'><input type='text' id='txtOtherAmphetamineCurrentUsePattern' name='txtOtherAmphetamineCurrentUsePattern' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtOtherAmphetamineDateLastUse' name='txtOtherAmphetamineDateLastUse' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>Drug used: </b>Other Stimulant</td>
                    </tr>
                    <tr>
                        <td className='w-187'><span className='eleHeader'>Age of 1st use</span></td>
                        <td className='w-187'><span className='eleHeader'>Age of regular use</span></td>
                        <td className='w-187'><span className='eleHeader'>*Route of use</span></td>
                        <td className='w-187'><span className='eleHeader'>Age of peak use</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='text' id='txtOtherStimulantFirstUse' name='txtOtherStimulantFirstUse' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtOtherStimulantRegularUse' name='txtOtherStimulantRegularUse' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtOtherStimulantRouteOfUse' name='txtOtherStimulantRouteOfUse' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtOtherStimulantAgePeakUse' name='txtOtherStimulantAgePeakUse' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-600'><span className='eleHeader'>Current pattern of use</span></td>
                        <td className='w-150'><span className='eleHeader'>Date of last use</span></td>
                    </tr>
                    <tr>
                        <td className='w-600'><input type='text' id='txtOtherStimulantCurrentUsePattern' name='txtOtherStimulantCurrentUsePattern' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtOtherStimulantDateLastUse' name='txtOtherStimulantDateLastUse' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>Drug used: </b>Benzos</td>
                    </tr>
                    <tr>
                        <td className='w-187'><span className='eleHeader'>Age of 1st use</span></td>
                        <td className='w-187'><span className='eleHeader'>Age of regular use</span></td>
                        <td className='w-187'><span className='eleHeader'>*Route of use</span></td>
                        <td className='w-187'><span className='eleHeader'>Age of peak use</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='text' id='txtBenzosFirstUse' name='txtBenzosFirstUse' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtBenzosRegularUse' name='txtBenzosRegularUse' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtBenzosRouteOfUse' name='txtBenzosRouteOfUse' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtBenzosAgePeakUse' name='txtBenzosAgePeakUse' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-600'><span className='eleHeader'>Current pattern of use</span></td>
                        <td className='w-150'><span className='eleHeader'>Date of last use</span></td>
                    </tr>
                    <tr>
                        <td className='w-600'><input type='text' id='txtBenzosCurrentUsePattern' name='txtBenzosCurrentUsePattern' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtBenzosDateLastUse' name='txtBenzosDateLastUse' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>Drug used: </b>Other Tranquilizer</td>
                    </tr>
                    <tr>
                        <td className='w-187'><span className='eleHeader'>Age of 1st use</span></td>
                        <td className='w-187'><span className='eleHeader'>Age of regular use</span></td>
                        <td className='w-187'><span className='eleHeader'>*Route of use</span></td>
                        <td className='w-187'><span className='eleHeader'>Age of peak use</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='text' id='txtOtherTranquilizerFirstUse' name='txtOtherTranquilizerFirstUse' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtOtherTranquilizerRegularUse' name='txtOtherTranquilizerRegularUse' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtOtherTranquilizerRouteOfUse' name='txtOtherTranquilizerRouteOfUse' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtOtherTranquilizerAgePeakUse' name='txtOtherTranquilizerAgePeakUse' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-600'><span className='eleHeader'>Current pattern of use</span></td>
                        <td className='w-150'><span className='eleHeader'>Date of last use</span></td>
                    </tr>
                    <tr>
                        <td className='w-600'><input type='text' id='txtOtherTranquilizerCurrentUsePattern' name='txtOtherTranquilizerCurrentUsePattern' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtOtherTranquilizerDateLastUse' name='txtOtherTranquilizerDateLastUse' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>Drug used: </b>Barbiturates</td>
                    </tr>
                    <tr>
                        <td className='w-187'><span className='eleHeader'>Age of 1st use</span></td>
                        <td className='w-187'><span className='eleHeader'>Age of regular use</span></td>
                        <td className='w-187'><span className='eleHeader'>*Route of use</span></td>
                        <td className='w-187'><span className='eleHeader'>Age of peak use</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='text' id='txtBarbituratesFirstUse' name='txtBarbituratesFirstUse' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtBarbituratesRegularUse' name='txtBarbituratesRegularUse' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtBarbituratesRouteOfUse' name='txtBarbituratesRouteOfUse' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtBarbituratesAgePeakUse' name='txtBarbituratesAgePeakUse' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-600'><span className='eleHeader'>Current pattern of use</span></td>
                        <td className='w-150'><span className='eleHeader'>Date of last use</span></td>
                    </tr>
                    <tr>
                        <td className='w-600'><input type='text' id='txtBarbituratesCurrentUsePattern' name='txtBarbituratesCurrentUsePattern' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtBarbituratesDateLastUse' name='txtBarbituratesDateLastUse' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>Drug used: </b>Other Sedative/Hypnotic</td>
                    </tr>
                    <tr>
                        <td className='w-187'><span className='eleHeader'>Age of 1st use</span></td>
                        <td className='w-187'><span className='eleHeader'>Age of regular use</span></td>
                        <td className='w-187'><span className='eleHeader'>*Route of use</span></td>
                        <td className='w-187'><span className='eleHeader'>Age of peak use</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='text' id='txtOtherSedativeHypnoticFirstUse' name='txtOtherSedativeHypnoticFirstUse' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtOtherSedativeHypnoticRegularUse' name='txtOtherSedativeHypnoticRegularUse' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtOtherSedativeHypnoticRouteOfUse' name='txtOtherSedativeHypnoticRouteOfUse' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtOtherSedativeHypnoticAgePeakUse' name='txtOtherSedativeHypnoticAgePeakUse' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-600'><span className='eleHeader'>Current pattern of use</span></td>
                        <td className='w-150'><span className='eleHeader'>Date of last use</span></td>
                    </tr>
                    <tr>
                        <td className='w-600'><input type='text' id='txtOtherSedativeHypnoticCurrentUsePattern' name='txtOtherSedativeHypnoticCurrentUsePattern' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtOtherSedativeHypnoticDateLastUse' name='txtOtherSedativeHypnoticDateLastUse' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>Drug used: </b>OTC (Over-the-counter)</td>
                    </tr>
                    <tr>
                        <td className='w-187'><span className='eleHeader'>Age of 1st use</span></td>
                        <td className='w-187'><span className='eleHeader'>Age of regular use</span></td>
                        <td className='w-187'><span className='eleHeader'>*Route of use</span></td>
                        <td className='w-187'><span className='eleHeader'>Age of peak use</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='text' id='txtOtcFirstUse' name='txtOtcFirstUse' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtOtcRegularUse' name='txtOtcRegularUse' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtOtcRouteOfUse' name='txtOtcRouteOfUse' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtOtcAgePeakUse' name='txtOtcAgePeakUse' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-600'><span className='eleHeader'>Current pattern of use</span></td>
                        <td className='w-150'><span className='eleHeader'>Date of last use</span></td>
                    </tr>
                    <tr>
                        <td className='w-600'><input type='text' id='txtOtcCurrentUsePattern' name='txtOtcCurrentUsePattern' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtOtcDateLastUse' name='txtOtcDateLastUse' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>Drug used: </b>Other</td>
                    </tr>
                    <tr>
                        <td className='w-187'><span className='eleHeader'>Age of 1st use</span></td>
                        <td className='w-187'><span className='eleHeader'>Age of regular use</span></td>
                        <td className='w-187'><span className='eleHeader'>*Route of use</span></td>
                        <td className='w-187'><span className='eleHeader'>Age of peak use</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='text' id='txtOtherFirstUse' name='txtOtherFirstUse' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtOtherRegularUse' name='txtOtherRegularUse' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtOtherRouteOfUse' name='txtOtherRouteOfUse' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtOtherAgePeakUse' name='txtOtherAgePeakUse' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-600'><span className='eleHeader'>Current pattern of use</span></td>
                        <td className='w-150'><span className='eleHeader'>Date of last use</span></td>
                    </tr>
                    <tr>
                        <td className='w-600'><input type='text' id='txtOtherCurrentUsePattern' name='txtOtherCurrentUsePattern' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtOtherDateLastUse' name='txtOtherDateLastUse' className='add-only' /></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Negative consequences individual identifies from use/abuse</span>
                            <span className='small'> (e.g. financial, health, loss of significant relationships, employment, housing, legal charges):</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtNegativeConsequencesIndividual' name='txtNegativeConsequencesIndividual' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>History of efforts to quit:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtHistoryOfEffortsToQuit' name='txtHistoryOfEffortsToQuit' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Methods used </span>
                            <span className='small'>(e.g., inpatient/outpatient treatment, AA/NA, on your own):</span>
                        </td>
                        <td className='w-375'><span className='eleHeader'>Effectiveness:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtMethodUsed' name='txtMethodUsed' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtEffectiveness' name='txtEffectiveness' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Family history of substance abuse:</span>                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtFamilyHistoryOfSubstanceAbuse' name='txtFamilyHistoryOfSubstanceAbuse' className='add-only' /></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Which statement most closely describes the individual&#39;s substance use pattern?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbDoesNotMeetCriteria' name='cbDoesNotMeetCriteria' className='add-only' value='DoesNotMeetCriteria' /> Does not meet criteria for substance abuse/dependence diagnosis.</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbMeetsCriteria' name='cbMeetsCriteria' className='add-only' value='MeetsCriteria' /> Meets criteria for substance abuse/dependence but does not identify this as a problem or does not desire treatment</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbRecognizesNegativeConsequences' name='cbRecognizesNegativeConsequences' className='add-only' value='RecognizesNegativeConsequences' /> Recognizes negative consequences of use but is ambivalent about desire to stop using.</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbMakingEffortsToReduceSubstance' name='cbMakingEffortsToReduceSubstance' className='add-only' value='MakingEffortsToReduceSubstance' /> Is making efforts to reduce use of substances (e.g., attending meetings, seeking support).</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbInEarlyRecovery' name='cbInEarlyRecovery' className='add-only' value='InEarlyRecovery' /> In early recovery and has not used for the past month.</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbNotUsedInThePast' name='cbNotUsedInThePast' className='add-only' value='NotUsedInThePast' /> Has not used in the past year</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbInSustainedRemission' name='cbInSustainedRemission' className='add-only' value='InSustainedRemission' /> In sustained remission and has not used in over a year.</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Last Use of Any Substances:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtLastUseOfAnySubstances' name='txtLastUseOfAnySubstances' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>History of Withdrawal Symptoms</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbNausea' name='cbNausea' className='add-only' value='Nausea' /> Nausea</td>
                        <td className='w-187'><input type='checkbox' id='cbVomiting' name='cbVomiting' className='add-only' value='Vomiting' /> Vomiting</td>
                        <td className='w-187'><input type='checkbox' id='cbCramping' name='cbCramping' className='add-only' value='Cramping' /> Cramping</td>
                        <td className='w-187'><input type='checkbox' id='cbSweating' name='cbSweating' className='add-only' value='Sweating' /> Sweating</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbAgitation' name='cbAgitation' className='add-only' value='Agitation' /> Agitation</td>
                        <td className='w-187'><input type='checkbox' id='cbHallucinations' name='cbHallucinations' className='add-only' value='Hallucinations' /> Hallucinations</td>
                        <td className='w-187'><input type='checkbox' id='cbTremors' name='cbTremors' className='add-only' value='Tremors' /> Tremors</td>
                        <td className='w-187'><input type='checkbox' id='cbBlackouts' name='cbBlackouts' className='add-only' value='Blackouts' /> Blackouts</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbCurrentDts' name='cbCurrentDts' className='add-only' value='CurrentDts' /> Current DT&#39;s</td>
                        <td className='w-187'><input type='checkbox' id='cbPastDts' name='cbPastDts' className='add-only' value='PastDts' /> Past DT&#39;s</td>
                        <td className='w-187'><input type='checkbox' id='cbCurrentSeizures' name='cbCurrentSeizures' className='add-only' value='CurrentSeizures' /> Current Seizures</td>
                        <td className='w-187'><input type='checkbox' id='cbPastSeizures' name='cbPastSeizures' className='add-only' value='PastSeizures' /> Past Seizures</td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Has the patient ever had suicidal thoughts or attempted suicide while using?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbEverHadSuicidalThoughtsWhileUsingNo' name='rbEverHadSuicidalThoughtsWhileUsing' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbEverHadSuicidalThoughtsWhileUsingYes' name='rbEverHadSuicidalThoughtsWhileUsing' className='add-only' value='Yes' /> Yes
                        </td>
                    </tr>
                </table>

                <p className='w-750'><center><h3>Staff Assessment</h3></center></p>
                <p className='w-750'><b>Dangerous to Self or Others (include reasons patient is or is not dangerous, document names, addresses, phone numbers of
                    intended victims when available; describe ideation/plan/intent; document staffing and mandatory reporting requirements, etc.)
                </b></p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Have you thought about harming yourself or others in the last 2 weeks?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbThoughtOfHarmingYourselfNo' name='rbThoughtOfHarmingYourself' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbThoughtOfHarmingYourselfYes' name='rbThoughtOfHarmingYourself' className='add-only' value='Yes' /> Yes
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>How likely are you to act on it?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbHowLikelyActOnItLikely' name='rbHowLikelyActOnIt' className='add-only' value='Likely' /> Likely &nbsp;
                            <input type='radio' id='rbHowLikelyActOnItNotLikely' name='rbHowLikelyActOnIt' className='add-only' value='NotLikely' /> Not Likely
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'><span className='eleHeader'>Do you have a gun?</span></td>
                        <td className='w-375'><span className='eleHeader'>Do you have access to a gun?</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbDoYouHaveGunsNo' name='rbDoYouHaveGuns' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbDoYouHaveGunsYes' name='rbDoYouHaveGuns' className='add-only' value='Yes' /> Yes
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbDoYouHaveAccessToGunsNo' name='rbDoYouHaveAccessToGuns' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbDoYouHaveAccessToGunsYes' name='rbDoYouHaveAccessToGuns' className='add-only' value='Yes' /> Yes
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h3>Suicidal Risk Assessment</h3></p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Ideation</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtSuicidalRiskAssessmentIdeation' name='txtSuicidalRiskAssessmentIdeation' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Intent</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtSuicidalRiskAssessmentIntent' name='txtSuicidalRiskAssessmentIntent' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Plan</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtSuicidalRiskAssessmentPlan' name='txtSuicidalRiskAssessmentPlan' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Means</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtSuicidalRiskAssessmentMeans' name='txtSuicidalRiskAssessmentMeans' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Attempts</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtSuicidalRiskAssessmentAttempts' name='txtSuicidalRiskAssessmentAttempts' className='add-only' /></td>
                    </tr>
                </table>


                <p className='w-750'><h3>Homicidal Risk Assessment</h3></p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Ideation</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtHomicidalRiskAssessmentIdeation' name='txtHomicidalRiskAssessmentIdeation' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Intent</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtHomicidalRiskAssessmentIntent' name='txtHomicidalRiskAssessmentIntent' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Plan</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtHomicidalRiskAssessmentPlan' name='txtHomicidalRiskAssessmentPlan' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Means</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtHomicidalRiskAssessmentMeans' name='txtHomicidalRiskAssessmentMeans' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Attempts</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtHomicidalRiskAssessmentAttempts' name='txtHomicidalRiskAssessmentAttempts' className='add-only' /></td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Prior Gestures</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtPriorGestures' name='txtPriorGestures' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Did any attempt require intensive medical treatment?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbAnyAttemptsRequireMedicalTreatmentNo' name='rbAnyAttemptsRequireMedicalTreatment' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbAnyAttemptsRequireMedicalTreatmentYes' name='rbAnyAttemptsRequireMedicalTreatment' className='add-only' value='Yes' /> Yes
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Did the person account for his or her own rescue?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbAccountForHisHerOwnRescueNo' name='rbAccountForHisHerOwnRescue' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbAccountForHisHerOwnRescueYes' name='rbAccountForHisHerOwnRescue' className='add-only' value='Yes' /> Yes
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Give date/details about the most recent attempt or gesture</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtDetailsOnPriorAttemptsOrGestures' name='txtDetailsOnPriorAttemptsOrGestures' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Short-term Risk for Suicide</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtShortTermRiskForSuicide' name='txtShortTermRiskForSuicide' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Long-term Risk for Suicide</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtLongTermRiskForSuicide' name='txtLongTermRiskForSuicide' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Short-term Risk for Violence/Homicide</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtShortTermRiskForHomicide' name='ShortTermRiskForHomicide' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Long-term Risk for Violence/Homicide</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtLongTermRiskForHomicide' name='txtLongTermRiskForHomicide' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><center><h3>Assessment of Strengths of Weaknesses and Protective Factor</h3></center></p>

                <p className='w-750'><b>Biological - </b>- Significant medical history, relevant injuries and physical issues; Does individual have best possible health (current
                    status), access to medical services, and control over own health?
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Strengths</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtBiologicalStrengths' name='txtBiologicalStrengths' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Weakness</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtBiologicalWeakness' name='txtBiologicalWeakness' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Biological Risks</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtBiologicalBiologicalRisks' name='txtBiologicalBiologicalRisks' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Protective Factors</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtBiologicalProtectiveFactors' name='txtBiologicalProtectiveFactors' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><b>Psychological - </b>- Ability to deal with stressful situations in the past, individual vulnerabilities and factors supporting resiliency. Does
                    the person experience continuity, security, and feel safe in current environment?
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Strengths</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtPsychologicalStrengths' name='txtPsychologicalStrengths' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Weakness</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtPsychologicalWeakness' name='txtPsychologicalWeakness' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Psychological Risks</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtPsychologicalPsychologicalRisks' name='txtPsychologicalPsychologicalRisks' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Protective Factors</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtPsychologicalProtectiveFactors' name='txtPsychologicalProtectiveFactors' className='add-only' /></td>
                    </tr>
                </table>


                <p className='w-750'><b>Family - </b>- Family history of mental illness, significant events from individual&#39;s history in relation to their family (e.g., abuse, neglect,
                    adoption), and strengths and vulnerabilities with regard to current family situation?
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Strengths</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtFamilyStrengths' name='txtFamilyStrengths' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Weakness</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtFamilyWeakness' name='txtFamilyWeakness' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Familial Risks</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtFamilyFamilialRisks' name='txtFamilyFamilialRisks' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Protective Factors</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtFamilyProtectiveFactors' name='txtFamilyProtectiveFactors' className='add-only' /></td>
                    </tr>
                </table>


                <p className='w-750'><b>Social/Environmental - </b>- Education, vocation - satisfied with current work situation? Significant relationships, number of
                    marriages, involvement in the community, strengths with current living situation (Ever homeless? Financial concerns) Religious
                    Preferences, Does the individual feel respected in various roles and environments, choose and realize personal goals, feel safe in
                    current environment, is involved in relationships of reciprocity and feel he/she can exercise his/her rights?

                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Strengths</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtEnvironmentalStrengths' name='txtEnvironmentalStrengths' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Weakness</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtEnvironmentalWeakness' name='txtEnvironmentalWeakness' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Social/Environmental Risks</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtEnvironmentalSocialRisks' name='txtEnvironmentalSocialRisks' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Protective Factors</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtEnvironmentalProtectiveFactors' name='txtEnvironmentalProtectiveFactors' className='add-only' /></td>
                    </tr>
                </table>


                <p className='w-750'><b>Developmental - </b>- prenatal history and birth (include prenatal exposure to alcohol, tobacco, and other drugs), milestones
                    appropriately met, learning, language/speech, abuse and neglect.

                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Strengths</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtDevelopmentalStrengths' name='txtDevelopmentalStrengths' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Weakness</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtDevelopmentalWeakness' name='txtDevelopmentalWeakness' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Developmental Risks</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtDevelopmentalDevelopmentalRisks' name='txtDevelopmentalDevelopmentalRisks' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Protective Factors</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtDevelopmentalProtectiveFactors' name='txtDevelopmentalProtectiveFactors' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><center><h3>Clinical Impression and Treatment Recommendations</h3></center></p>
                <p className='w-750'><center>Strength and problem summary which addresses individual&#39;s signs and symptoms supporting diagnosis</center></p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Risk for Harm Summary</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtHarmSummary' name='txtHarmSummary' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Functional status Summary</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtFunctionalSummary' name='txtFunctionalSummary' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Co-morbidity Summary</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtComorbiditySummary' name='txtComorbiditySummary' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Current recovery environment and treatment/recovery history Summary</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtCurrentRecoveryEnvironmentSummary' name='txtCurrentRecoveryEnvironmentSummary' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Identified Patient Needs and Placement Criteria</span>
                    <textarea id='txtIdentifiedPatientNeedsPlacementCriteria' name='txtIdentifiedPatientNeedsPlacementCriteria' className='add-only' ></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>INTERDISCIPLINARY Team Note and Conclusion of Assessment  </span>
                    <span className='small'>(include evaluation of findings, rationale for recommendations and disposition, need for second opinion, etc.):</span>
                    <textarea id='txtInterdisciplinaryeamConclusionAssessment' name='txtInterdisciplinaryeamConclusionAssessment' className='add-only' ></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Interdisciplinary Team Discussion/Review Date</span></td>
                        <td className='w-500'><span className='eleHeader'>Recommended Treatment including Rationale</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='date' id='txtInterdisciplinaryTeamDiscussionDate' name='txtInterdisciplinaryTeamDiscussionDate' className='add-only' /></td>
                        <td className='w-500'><input type='text' id='txtRecommendedTreatmentRationale' name='txtRecommendedTreatmentRationale' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><center><h3>Diagnostic Impression (include diagnosis code and description)</h3></center></p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'><b>DSM Diagnoses</b> in order from primary to tertiary presenting problems:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtDsmDiagnoses' name='txtDsmDiagnoses' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'><b>Current GAF</b> if assessed:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtCurrentGaf' name='txtCurrentGaf' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Target Population:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtTargetPopulation' name='txtTargetPopulation' className='add-only' /></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Screening Disposition</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbAppearsMillenniumConsulting' name='cbAppearsMillenniumConsulting' className='add-only' value='AppearsMillenniumConsulting' />
                            It appears that Millennium Consulting, LLC can adequately address the individual&#39;s needs</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbProgramAtMillenniumConsulting' name='cbProgramAtMillenniumConsulting' className='add-only' value='ProgramAtMillenniumConsulting' />
                            The programs at Millennium Consulting, LLC cannot meet the individual&#39;s needs. Recommendations will be made for other resources to
                            meet the current service needs of the individual.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>(Select all that apply)</b></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbPatientAgreed' name='cbPatientAgreed' className='add-only' value='PatientAgreed' />
                            Patient agreed to and scheduled to begin specified services upon authorization (see service plan)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbPatientService' name='cbPatientService' className='add-only' value='PatientService' />
                            Patient service plan to be completed at next appointment
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbPatientFollowUp' name='cbPatientFollowUp' className='add-only' value='PatientFollowUp' />
                            Patient scheduled for follow -up assessment to further clarify diagnoses and/or treatment needs; not admitted at this time.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbClinicianToStaff' name='cbClinicianToStaff' className='add-only' value='ClinicianToStaff' />
                            Clinician to staff with TX team for further recommendations—not admitted at this time
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbContinuumCareStaff' name='cbContinuumCareStaff' className='add-only' value='ContinuumCareStaff' />
                            Continuum Care staff will contact consumer with further information/appointment times
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbPatientInCrisis' name='cbPatientInCrisis' className='add-only' value='PatientInCrisis' />
                            Patient in crisis and in need of inpatient placement; See additional progress note documentation for information related to
                            placement and disposition specifics
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbNoFurtherTreatmentIndicated' name='cbNoFurtherTreatmentIndicated' className='add-only' value='NoFurtherTreatmentIndicated' />
                            No further treatment is indicated
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbPatientRefusesTreatment' name='cbPatientRefusesTreatment' className='add-only' value='PatientRefusesTreatment' />
                            Patient refuses treatment recommendations; therefore, no further services are scheduled
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbScreeningDispositionOther' name='cbScreeningDispositionOther' className='add-only' value='ScreeningDispositionOther' />
                            Other (specify):
                            <input type='text' id='txtScreeningDispositionOther' name='txtScreeningDispositionOther' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>** I/My family participated and provided information necessary to complete this assessment. I understand that this information will be
                            used to guide further treatment plans and service recommendations.</span></td>
                    </tr>

                    <tr>
                        <td className='signature w-750'></td>
                    </tr>
                    <tr>
                        <td className='small w-750'> Signature of Person to Receive Services or Legally Responsible Party </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'></td>
                        <td className='signature w-375'></td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Relation to patient </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>

                <table>

                    <tr>
                        <td className='w-750'><center><h3>Assessment Team Signatures</h3></center></td>
                    </tr>

                    <tr>
                        <td className='signature w-750'></td>
                    </tr>
                    <tr>
                        <td className='small w-750'> Licensed Professional Printed Name </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'></td>
                        <td className='signature w-375'></td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Signature and Credentials </td>
                        <td className='small w-375'> Date </td>
                    </tr>

                    <tr>
                        <td className='signature w-750'></td>
                    </tr>
                    <tr>
                        <td className='small w-750'> Licensed Professional Printed Name </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'></td>
                        <td className='signature w-375'></td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Signature and Credentials </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    

                    <tr>
                        <td className='signature w-750'></td>
                    </tr>
                    <tr>
                        <td className='small w-750'> Licensed Professional Printed Name </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'></td>
                        <td className='signature w-375'></td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Signature and Credentials </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>

                <p className='w-750'><input type='checkbox' id='cbDiagnosticAssessment' name='cbDiagnosticAssessment' className='add-only' value='DiagnosticAssessment' /> 
                Check the box if this assessment meets minimum requirements for <b>Diagnostic Assessment (for Billing Purposes ONLY).</b>
                </p>
 
            </div>
        </form>

    )
}







